import React, { useState } from 'react';
import { Box, Select, MenuItem, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

export default function StatusCell({ row, labels = [], value, onChange, onLabelsEdit }) {
  const [openEdit, setOpenEdit] = useState(false);

  const handleOpenEdit = () => {
    setOpenEdit(true);
    if (onLabelsEdit) onLabelsEdit();
  };

  const handleCloseEdit = () => setOpenEdit(false);

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Box sx={{ width: 10, height: 10, borderRadius: 1, bgcolor: value === 'Active' ? '#66bb6a' : value === 'Exiting' ? '#ffb74d' : '#9e9e9e' }} />

      <Select
        size="small"
        value={value || ''}
        onChange={(e) => onChange && onChange(e.target.value)}
        sx={{ minWidth: 120 }}
      >
        <MenuItem value="">--</MenuItem>
        {labels.map((l) => (
          <MenuItem key={l} value={l}>{l}</MenuItem>
        ))}
      </Select>

      <Tooltip title="Edit labels">
        <IconButton size="small" onClick={handleOpenEdit}>
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {/* The parent page will provide a full edit labels UX; keep this dialog minimal in case parent doesn't provide one. */}
      <Dialog open={openEdit} onClose={handleCloseEdit} fullWidth maxWidth="sm">
        <DialogTitle>Edit Status Labels</DialogTitle>
        <DialogContent>
          <Stack spacing={1} sx={{ mt: 1 }}>
            <TextField value={labels.join(', ')} size="small" fullWidth disabled helperText="Label editing is available in the manager (the page provides a full editor)." />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseEdit}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
